import { Pill } from "@/components/podkit/status/Pill";
import type { PlainProject } from "@/queries/project-queries";
import { ProjectPhase } from "gitpod-next-api/gitpod/v1/project_pb";
import { type FC, useMemo } from "react";

type PhaseTagInfo = {
    variant: "danger";
    name: string;
    tooltip: string;
} | null;

type ProjectPhaseTagProps = {
    project: PlainProject;
    prebuildCount?: number;
};

export const ProjectPhaseTag: FC<ProjectPhaseTagProps> = ({ project, prebuildCount }) => {
    const phaseInfo = useMemo<PhaseTagInfo>(() => {
        const desired = project.desiredPhase;

        switch (desired) {
            case ProjectPhase.DELETED: {
                const count = prebuildCount ?? 0;
                const prebuildText = count === 1 ? "prebuild" : "prebuilds";
                return {
                    variant: "danger" as const,
                    name: "Pending deletion",
                    tooltip: `This project is being deleted. ${count} ${prebuildText} ${count === 1 ? "is" : "are"} being cleaned up.`,
                };
            }
            case ProjectPhase.ACTIVE:
            default:
                // Don't show a tag for active projects
                return null;
        }
    }, [project, prebuildCount]);

    if (!phaseInfo) {
        return null;
    }

    return (
        <Pill variant={phaseInfo.variant} tooltip={phaseInfo.tooltip}>
            {phaseInfo.name}
        </Pill>
    );
};
